import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdNotificationPreferencesBulkAddCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/notification_preferences/list",
];
